<p-button label="{{ label | translate }}" icon="pi pi-plus" class="p-button-rounded" (click)="create()"></p-button>
